/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data-ids used for adding to set.
 * @export
 */
export const ADD_COMPONENT_TO_SET_DATA_IDS = {
  addToSetButton: `Add to set button`,
  addToSetStep1: `Add to set: Step One - Choose component`,
  addToSetStep2: `Add to set: Step Two - Configure component`,
  backToAllComponents: `back-to-all-components`,
  componentItem: `Component item`,
  createNewOverride: `CREATE_NEW_OVERRIDE`,
  editableVersioningOptions: `editable-versioning-options`,
  editableVersionsLatest: `EDITABLE_VERSIONS_LATEST`,
  editableVersionsNone: `EDITABLE_VERSIONS_NONE`,
  editableVersionsSpecific: `EDITABLE_VERSIONS_SPECIFIC`,
  environmentVariableInput: `environment-variable-input`,
  environmentVariableOptions: `environment-variable-options`,
  excludedVersioningOptions: `excluded-versioning-options`,
  loadMore: `Load more`,
  renderableVersioningOptions: `renderable-versioning-options`,
  renderableVersioningSpecifyRangeInput: `specify-renderable-range-input`,
  renderableVersionsAll: `RENDERABLE_VERSION_ALL`,
  renderableVersionsSpecify: `RENDERABLE_VERSION_SPECIFY`,
  searchComponentsInput: `search-components-input`,
  setGlobalVariable: `SET_GLOBAL_VARIABLE`,
  specifyVersions: `SPECIFY_VERSIONS`,
  useLatestVersion: `USE_LATEST_VERSION`,
  versioningOptions: `versioning-options`,
  versionOptions: `version-options`,
  versionRules: `version-rules`,
  versionRulesInput: `version-rules-input`,
};
